import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ICaseFile } from '../../modules/cases/interfaces/case-file.interface';
import { ICase } from '../../modules/cases/interfaces/case.interface';
import { CasesData } from '../../modules/cases/interfaces/cases-data.interface';
import { UserService } from './user.service';
import { EnvService } from 'src/app/services/env.service';

@Injectable()
export class CasesService {
  readonly auditoryUrl: string = `${this.env.URL_API_V1}/auditory_log`;
  readonly baseUrl = `${this.env.URL_API_V1}/case`;
  readonly filesUrl = `${this.env.URL_API_V1}/caseFile`;
  readonly caseRecordUrl = `${this.env.URL_API_V1}/case_record`;
  constructor(
    private readonly http: HttpClient,
    private userService: UserService,
    private env: EnvService
  ) {}

  saveAuditory(type: string, more_info: any) {
    // Type can be delete, create or update
    const url = `${this.auditoryUrl}`;
    const auditory = {
      user: this.userService.currentUser,
      action: type,
      more_info,
    };
    return this.http.post(url, auditory);
  }
  caseStyleContent = new Subject<string>();
  filterData = new Subject();
  filterDataRas = new Subject();
  filterDataRasSearch = new Subject();
  filterRecord = new Subject();
  filterRecordCases = new Subject();

  getDataByUnit(unit, filters) {
    return this.http.get<CasesData[]>(`${this.baseUrl}/byUnit/${unit}`, {
      params: filters,
    });
  }
  getDataByUnitOnly(unit) {
    return this.http.get<CasesData[]>(`${this.baseUrl}/onlyByUnit/${unit}`);
  }

  getDataByUnitFilter(unit, filters) {
    return this.http.get<CasesData[]>(`${this.baseUrl}/filterByUnit/${unit}`, {
      params: filters,
    });
  }
  getDataByUnitList(unit, filters) {
    return this.http.get<CasesData[]>(`${this.baseUrl}/getListCases/${unit}`, {
      params: filters,
    });
  }
  getListCasesWhitoutAssigned(unit, filters) {
    return this.http.get<CasesData[]>(
      `${this.baseUrl}/getListCasesWhitoutAssigned/${unit}`,
      {
        params: filters,
      }
    );
  }
  getCase(id) {
    return this.http.get<ICase>(`${this.baseUrl}/get/${id}`);
  }
  getCases() {
    return this.http.get<ICase>(`${this.baseUrl}/getAll`);
  }
  updateStatusAndOrder(cases: ICase[]) {
    this.http
      .put(`${this.baseUrl}/statusAndOrder`, { cases })
      .pipe(take(1))
      .subscribe();
  }

  create(data) {
    return this.http.post<ICase>(`${this.baseUrl}/create`, data);
  }

  caseCreated = new Subject<ICase>();

  delete(id, user) {
    // this.getCase(id).subscribe((data) => {
    //   this.saveAuditory('DeleteCase', data).subscribe((res) => {});
    // });
    return this.http.post(`${this.baseUrl}/delete/${id}`, user);
  }

  caseDeleted = new Subject<ICase>();
  caseDeletedDismiss = new Subject<ICase>();
  caseEdited = new Subject<ICase>();
  caseFinished = new Subject<ICase>();

  update(id, data) {
    return this.http.put<ICase>(`${this.baseUrl}/update/${id}`, data);
  }

  finishCase(id, body) {
    return this.http.put(`${this.baseUrl}/finish/${id}`, body);
  }

  getFiles(id) {
    return this.http.get<ICaseFile[]>(`${this.filesUrl}/byCase/${id}`);
  }
  countPendingtasks(id) {
    return this.http.get<number>(`${this.baseUrl}/taskPending/${id}`);
  }

  createCaseAdditionalInformation(id: string, additionalInformation: any) {
    let url = `${this.baseUrl}/update/${id}`;
    return this.http.put<ICase>(url, { additionalInformation });
  }

  getAuditory(): Observable<any> {
    const url = `${this.auditoryUrl}/getAllLogs`;
    return this.http.get(url);
  }
  getAllRecordFilters(filters): Observable<any> {
    return this.http.get(`${this.auditoryUrl}/getAllRecordFilters`, {
      params: filters,
    });
  }

  getAllRecordCasesFilters(filters): Observable<any> {
    return this.http.get(`${this.caseRecordUrl}/getAllRecordCasesFilters`, {
      params: filters,
    });
  }
  getAllCaseRecords(): Observable<any> {
    return this.http.get(`${this.caseRecordUrl}/getAllRecordCases`);
  }

  createCaseToCAECAI(data) {
    return this.http.post<ICase>(`${this.baseUrl}/createCaseToCAECAI`, data);
  }

  updateCaseCSA(id, data) {
    //BT
    return this.http.put<ICase>(`${this.baseUrl}/updateCaseCSA/${id}`, data);
  }
}
